export function getSubPage() {
  return window.localStorage.getItem("sub_page");
}

export function setSubPage(subPageIdToken) {
  window.localStorage.setItem("sub_page", subPageIdToken);
}
